module.exports = __webpack_public_path__ + "static/media/chevronTourRight.131a6011.svg";